const config = {
  server: window._env_.REACT_APP_API_URL,
  apiURL: window._env_.REACT_APP_API_URL + "/api",
  duration: 5,
  keyLongdo: "d49bc9f7b37b9cf827ea81718fd1e2c0",
};
export default config;
